import axios from 'axios';
import oauth from 'webmd-oauth/src/index.es6';
import CryptoJS from 'crypto-js';

let cred = {};
const axiosInstance = {};
const appName = 'spiider-api';

const PROD_CRED = {
	client_id: 'ffd1790e-63c1-4c47-a6b9-e78fddd2de60',
	secret_key: '8e014638-6038-466b-9ca7-73d64ba0cb64',
};

const QA_CRED = {
	client_id: 'ffd1790e-63c1-4c47-a6b9-e78fddd2de60',
	secret_key: 'e703acf7-42a7-49f6-8346-54515c7c7876',
};
export function getEnvironment(domain = '') {
	let servicedomain = 'https://doctor.webmd.com';
	let nodeservicedomain = 'https://www.webmd.com/kapi/secure';
	let host;
	let env = '';
	if (typeof window !== 'undefined') {
		host = window.location.host.toLowerCase();
		servicedomain = 'https://www.webmd.com';
		if (host.indexOf('localhost') >= 0) {
			// servicedomain = 'https://doctor.qa.webmd.com';
			servicedomain = 'https://www.dev01.webmd.com';
			nodeservicedomain = 'https://www.qa.webmd.com/kapi/secure';
			cred = QA_CRED;
		} else if (host.indexOf('.feature') > 0) {
			servicedomain = 'https://www.dev01.webmd.com';
			nodeservicedomain = 'https://www.qa.webmd.com/kapi/secure';
			cred = QA_CRED;
		} else if (host.indexOf('.devint') > 0) {
			servicedomain = 'https://www.dev01.webmd.com';
			nodeservicedomain = 'https://www.qa.webmd.com/kapi/secure';
			cred = QA_CRED;
		} else if (host.indexOf('.qa') > 0) {
			servicedomain = 'https://doctor.qa.webmd.com';
			nodeservicedomain = 'https://www.qa.webmd.com/kapi/secure';
			cred = QA_CRED;
		} else if (host.indexOf('.preview') > 0) {
			servicedomain = 'https://doctor.staging.webmd.com';
			nodeservicedomain = 'https://www.staging.webmd.com/kapi/secure';
			cred = PROD_CRED;
		} else if (host.indexOf('.staging') > 0) {
			servicedomain = 'https://doctor.staging.webmd.com';
			nodeservicedomain = 'https://www.staging.webmd.com/kapi/secure';
			cred = PROD_CRED;
		} else {
			servicedomain = 'https://doctor.webmd.com';
			nodeservicedomain = 'https://www.webmd.com/kapi/secure';
			cred = PROD_CRED;
		}
	} else if (domain !== '') {
		host = domain.toLowerCase();
		servicedomain = `http://qa-${appName}.webmd-qa`;
		if (host.indexOf('localhost') >= 0) {
			servicedomain = `http://searchsvc-${appName}.k8s.devint.webmd.com`;
			env = 'devint';
		} else if (host === 'feature') {
			servicedomain = `http://devint-${appName}.webmd-devint`;
			env = 'devint';
		} else if (host === 'devint') {
			servicedomain = `http://devint-${appName}.webmd-devint`;
			env = 'devint';
		} else if (host === 'qa') {
			servicedomain = `http://qa-${appName}.webmd-qa`;
			env = 'qa';
		} else if (host === 'preview') {
			servicedomain = `http://preview-${appName}.webmd-preview`;
			env = 'preview';
		} else if (host === 'staging') {
			servicedomain = `http://staging-${appName}.webmd-staging`;
			env = 'staging';
		} else {
			servicedomain = `http://production-${appName}.webmd-prod`;
			env = '';
		}
	} else {
		servicedomain = `http://searchsvc-${appName}.k8s.webmd.com`;
	}
	return {
		servicedomain,
		env,
		nodeservicedomain,
	};
}
export function getOAuthHeaders() {
	return new Promise((resolve) => {
		resolve(oauth.generate());
	});
}
export function makeSpiderApiCall(url, domain) {
	return getOAuthHeaders().then(
		(oauthHeaders) => {
			const searchapi = getEnvironment(domain).servicedomain;
			return axios.get(`${searchapi}${url}`, { headers: oauthHeaders });
		},
		(error) => {
			// eslint-disable-next-line no-console
			console.log('Error in getting oAuth headers', error);
		},
	);
}
export function generateOAuthHeaders(options) {
	const settings = { ...options };
	const timestamp = Math.floor(new Date().getTime() / 1000);

	if (!CryptoJS) {
		// eslint-disable-next-line no-console
		console.error('webmd.oauth error: CryptoJS module not loaded');
	} else {
		return {
			enc_data: CryptoJS.enc.Base64.stringify(
				CryptoJS.HmacSHA256(
					`{{timestamp:${timestamp},client_id:${settings.client_id}}}`,
					settings.secret_key,
				),
			),
			timestamp,
			client_id: settings.client_id,
		};
	}
	return {};
}
export function getNodeServiceOAuthHeaders(options) {
	return new Promise((resolve) => {
		resolve(generateOAuthHeaders(options));
	});
}
export function makeNodeServiceCall(url, domain) {
	const serviceapi = getEnvironment(domain).nodeservicedomain;
	return getNodeServiceOAuthHeaders(cred).then(
		(oauthHeaders) => {
			if (typeof window === 'undefined' && axiosInstance[serviceapi]) {
				return axiosInstance[serviceapi].get(url, {
					headers: oauthHeaders,
				});
			}
			return axios.get(`${serviceapi}${url}`, {
				headers: oauthHeaders,
			});
		},
		(error) => {
			// eslint-disable-next-line no-console
			console.log('Error in getting oAuth headers', error);
		},
	);
}
export function getFallbackLocation() {
	if (typeof window !== 'undefined') {
		const browserhost = window.location.hostname.toLowerCase();
		if (browserhost.indexOf('localhost') > -1) {
			return axios.get(
				'https://www.webmd.com/api/directories/Service.svc/location',
			);
		}
	}
	if (
		typeof document !== 'undefined'
		&& document.cookie
		&& document.cookie.indexOf('gtinfo=') !== -1
		&& document.cookie.match('gtinfo={(.*?)}')
	) {
		const gtinfoCookie = JSON.parse(
			`{${document.cookie.match('gtinfo={(.*?)}')[1]}}`,
		);
		return new Promise((resolve) => {
			resolve({
				data: {
					data: gtinfoCookie,
				},
			});
		});
	}
	return axios.get(
		'https://www.webmd.com/api/directories/Service.svc/location',
	);
}
